import React, { useEffect, useState } from 'react';
import { getBackendApiUrl } from '../../config/env';
import { fastapiService } from '../../services/fastapiService';

export const SystemPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');
  const [health, setHealth] = useState<any>(null);
  const [queues, setQueues] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError('');
        const [healthRes, queuesRes] = await Promise.all([
          fastapiService.getSystemHealth(),
          fastapiService.getQueueStats(),
        ]);
        setHealth(healthRes);
        setQueues(queuesRes);
      } catch (err: any) {
        setError(err?.message || 'Failed to load system data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const openBullBoard = () => {
    const baseUrl = getBackendApiUrl();
    const url = `${baseUrl.replace(/\/$/, '')}/api/v1/admin/bull-board`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-admin-900">System</h1>
        <p className="mt-1 text-sm text-admin-600">
          System configuration and maintenance
        </p>
      </div>
      
      <div className="admin-card p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-admin-900">Health</h2>
          <button onClick={openBullBoard} className="admin-button h-9 px-4 bg-primary-600 text-white hover:bg-primary-700">
            Open Bull Board
          </button>
        </div>
        {loading && <p className="text-admin-500">Loading...</p>}
        {error && <p className="text-red-600">{error}</p>}
        {!loading && !error && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-lg border p-4">
              <div className="text-sm text-admin-500">Overall Status</div>
              <div className="mt-1 text-xl font-semibold">
                {health?.status || 'unknown'}
              </div>
              <div className="mt-2 text-sm">
                Redis: {health?.services?.redis?.status || 'unknown'}
              </div>
              <div className="text-sm">DB: {health?.services?.database?.status || 'unknown'}</div>
            </div>
            <div className="rounded-lg border p-4">
              <div className="text-sm text-admin-500">Redis</div>
              <div className="mt-1 text-sm">Clients: {queues?.redis?.connected_clients ?? '-'}</div>
              <div className="text-sm">Memory: {queues?.redis?.used_memory_human ?? '-'}</div>
              <div className="text-sm">Uptime: {queues?.redis?.uptime_in_seconds ?? '-'}</div>
            </div>
          </div>
        )}
      </div>

      <div className="admin-card p-6 space-y-4">
        <h2 className="text-lg font-semibold text-admin-900">Queues</h2>
        {queues?.queues ? (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            {Object.entries(queues.queues).map(([name, stats]: any) => (
              <div key={name} className="rounded-lg border p-4">
                <div className="text-sm text-admin-500">{name}</div>
                <div className="mt-1 text-xl font-semibold">{stats.waiting ?? 0} waiting</div>
                <div className="text-sm">active: {stats.active ?? 0}</div>
                <div className="text-sm">completed: {stats.completed ?? 0}</div>
                <div className="text-sm">failed: {stats.failed ?? 0}</div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-admin-500">No queue data available</p>
        )}
      </div>
    </div>
  );
};

